import dayjs from "dayjs";
const formatDate = 'DD/MM/YYYY'

const dateEffetFn = (dateEffet, couvertureSante) => {
    const date = dayjs(dateEffet, formatDate, true)
    const dateEffetFrom = dayjs(dateEffetFromFn(couvertureSante), formatDate, true)

    if (date < dateEffetFrom) {
        return dateEffetFrom.format(formatDate)
    }

    return dateEffet
}

const dateEffetAncienContratFn = (dateEffetAncienContrat) => {
    const date = dayjs(dateEffetAncienContrat, formatDate, true)
    const yesterdayDate = dayjs().subtract(1, 'days')

    if (date > yesterdayDate) {
        return yesterdayDate.format(formatDate)
    }

    return dateEffetAncienContrat
}

const dateEffetFromFn = (couvertureSante) => {
    if (couvertureSante === "0") {
        const todayDate = dayjs()
        return todayDate.format(formatDate)
    } else {
        const date = dayjs().add(1, 'months').add(1, 'days')
        return date.format(formatDate)
    }
}

const dateEffetToFn = () => {
    const date = dayjs().add(6, 'months')
    return date.format(formatDate)
}

export {
    dateEffetAncienContratFn,
    dateEffetFn,
    dateEffetFromFn,
    dateEffetToFn
}
